import { useContext, useEffect } from 'react';

import { PageExportContext } from './chart-menu/PageExportProvider';

/** Keeps page exports waiting while one part of a chart is still resolving. */
export const useHoldExportWhilePending = (
  chartId: string | undefined,
  part: string,
  isPending: boolean
) => {
  const updateChartLoadingState =
    useContext(PageExportContext)?.updateChartLoadingState;
  useEffect(() => {
    if (!chartId || !updateChartLoadingState) return;
    const loadingKey = `${chartId}:gauge-${part}`;
    updateChartLoadingState(loadingKey, isPending);
    return () => updateChartLoadingState(loadingKey, false);
  }, [chartId, part, updateChartLoadingState, isPending]);
};
